// @ts-ignore
interface LoaderType {
  src: string
}
export const imageLoader = ({ src }: LoaderType) => src
